/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { NEGOTIABLE_QUOTE_TEMPLATE_FRAGMENT } from "../../graphql/NegotiableQuoteTemplateFragment";

export const CREATE_QUOTE_TEMPLATE_MUTATION = /* GraphQL */ `
  mutation CREATE_QUOTE_TEMPLATE_MUTATION($cartId: ID!) {
    requestNegotiableQuoteTemplateFromQuote(input: { cart_id: $cartId }) {
      ...NegotiableQuoteTemplateFragment
    }
  }

  ${NEGOTIABLE_QUOTE_TEMPLATE_FRAGMENT}
`;
